import routes from './routes';
import { SetRoutes } from 'components';

const VacanciesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VacanciesPages;
